import { hasCapability, type User } from "../base";

export const fileAnnotation = {
  read: (user: User) => hasCapability(user, "fileAnnotation.read"),
  update: (user: User) => hasCapability(user, "fileAnnotation.update"),
};
